"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUser = exports.signOut = exports.createAuthenticationRequestInit = exports.getProviderLoginUrl = void 0;
const enum_1 = require("../enum");
const hostname_1 = require("../hostname");
const getProviderLoginUrl = (provider, baseUrl = "", sessionId) => {
    const hostname = hostname_1.Hostname.auth.signin();
    const redirectPath = sessionId
        ? `?redirectPath=session/${sessionId}/live`
        : "";
    const path = `auth/${provider}/login${redirectPath}`;
    if (process.env.NODE_ENV === "development") {
        return `${hostname}/${path}`;
    }
    return `${baseUrl}/${path}`;
};
exports.getProviderLoginUrl = getProviderLoginUrl;
const createAuthenticationRequestInit = ({ email, password, }) => {
    const body = new URLSearchParams();
    body.append("username", email);
    body.append("password", password);
    return {
        method: enum_1.HttpMethods.POST,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        redirect: "follow",
        credentials: "include",
        body,
    };
};
exports.createAuthenticationRequestInit = createAuthenticationRequestInit;
const signOut = (baseUrl = "") => {
    const hostname = hostname_1.Hostname.auth.signout();
    window.location.href = `${baseUrl || hostname}/auth/logout?redirectUrl=${window.location.href}`;
};
exports.signOut = signOut;
const validateUser = (user) => {
    return !!(user && user.id && user.name && user.imageUrl);
};
exports.validateUser = validateUser;
//# sourceMappingURL=index.js.map